import { computed, watchEffect } from 'vue'
import { useHead } from '@unhead/vue'
import { useBrandingStore } from '@/stores/branding'

// Сервер всегда отдаёт наши favicon и title: он не знает, куда SPA отправит гостя (защищённый
// путь кончается на /login), поэтому клиентские ставятся здесь и только на маршрутах со входом.
export const useDocumentBranding = () => {
  const route = useRoute()
  const brandingStore = useBrandingStore()

  const productTitle = document.title
  const faviconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
  const productFaviconHref = faviconLink?.getAttribute('href') ?? ''

  // До первой навигации у маршрута нет ни записей, ни meta.
  const isSignInRequired = computed(() => route.matched.length > 0
    && !route.meta.public
    && !route.meta.unauthenticatedOnly)

  // Запись создаётся раньше страниц, поэтому title из useHead страницы её перекрывает.
  useHead({
    title: computed(() => (isSignInRequired.value && brandingStore.organizationBrowserTitle)
      ? brandingStore.organizationBrowserTitle
      : productTitle),
  })

  watchEffect(() => {
    if (!faviconLink)
      return

    const organizationFavicon = isSignInRequired.value ? brandingStore.organizationFavicon : ''

    if (organizationFavicon) {
      faviconLink.type = 'image/svg+xml'
      faviconLink.href = `data:image/svg+xml;base64,${organizationFavicon}`
    }
    else {
      faviconLink.removeAttribute('type')
      faviconLink.href = productFaviconHref
    }
  })
}
